import { render, staticRenderFns } from "./PersonCoursesTable.vue?vue&type=template&id=a8ad7b98&"
import script from "./PersonCoursesTable.vue?vue&type=script&lang=js&"
export * from "./PersonCoursesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports